const _ = require("lodash");
const {
	findArguments,
	makeFormattedText,
	makeMathCommandNode,
} = require("../util/ParserHelpers");

const lizzieNonmathParser = function(ps) {
	return makeFormattedText("lizzie", findArguments(ps, 1)[0]);
};

const lizzieMathParser = function(ps) {
	return makeMathCommandNode("lizzie", findArguments(ps, 1));
};

const lizzieNode = {
	draw(rc, x, y, node, measure) {
		return rc.drawNode(rc, x, y, node.children[0]);
	},
	measure(rc, fontInfo, props, node) {
		const newFontInfo = _.extend({}, fontInfo, {family: ["lizzie"]});
		return rc.measureNode(rc, newFontInfo, props, node.children[0]);
	},
	readAloud: {children: true},
};

module.exports = {
	parsers: {
		nonmathCommands: {
			lizzie: lizzieNonmathParser,
		},
		mathCommands: {
			lizzie: lizzieMathParser,
		},
	},
	nodes: {
		lizzie: lizzieNode,
	},
};
